/* eslint-disable react-hooks/exhaustive-deps */
import { Input } from '.';
import styled, { css } from 'styled-components';
import './expandable-input.css';
import { COLORS } from 'helpers/constants';
import { changeHeight } from 'helpers/styles';
import { useEffect, useState } from 'react';
import { Select } from 'components/select';

const StyleInput = styled(Input.Search)`
  .ant-input-affix-wrapper {
    padding: 4px 11px;
    background: ${COLORS.PRIMARY.WHITE};
    height: 40px;

    &:hover,
    &:focus,
    &-focused {
      border-right: none;
    }
  }
  ::placeholder {
    color: ${COLORS.PRIMARY.GRAY};
  }

  .ant-input-search-button {
    border: 1px solid;
    border-left: none;
    height: 40px !important;

    ${(props) =>
      !props.size
        ? css`
            ${changeHeight}
          `
        : ''}
  }

  .ant-select-selector {
    height: auto !important;
    padding-top: 0 !important;
  }
`;

export type SearchText = {
  text: string;
  type: string;
  is_documents?: boolean;
  is_drafts?: boolean;
  is_all?: boolean;
  allowDocumentCount?: boolean;
};

type Props = {
  setSearchText: ({ text, type }: SearchText) => void;
  serachType?: string;
};

export const ExpandableInput = ({ setSearchText, serachType }: Props) => {
  const [type, setType] = useState('node');
  const [value, setValue] = useState<string>();

  const options = serachType
    ? [
        { label: 'Connections', value: 'false' },
        { label: 'Drafts', value: 'true' },
      ]
    : [
        { label: 'All', value: 'true' },
        { label: 'Nodes', value: 'node' },
        { label: 'Documents', value: 'document' },
        { label: 'Drafts', value: 'draft' },
      ];

  const defaultValue = serachType ? 'false' : 'true';

  const selectAfter = (
    <Select
      defaultValue={defaultValue}
      popupMatchSelectWidth={150}
      dropdownStyle={{}}
      options={options}
      onSelect={(value) => setType(value as string)}
    />
  );

  const onDocumentChange = () => {
    if (!value) {
      setSearchText({
        text: '',
        type: 'node',
        allowDocumentCount: type === 'documen t',
        is_documents: type === 'document',
        is_drafts: type === 'draft',
        is_all: type === 'true',
      });
    } else {
      setSearchText({
        text: value,
        type,
        allowDocumentCount: false,
        is_documents: type === 'document',
        is_drafts: type === 'draft',
        is_all: type === 'node' ? true : false,
      });
    }
  };

  useEffect(() => {
    onDocumentChange();
  }, [type, setSearchText]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', backgroundColor: COLORS.PRIMARY.WHITE }}>
      <StyleInput
        placeholder="search"
        addonBefore={selectAfter}
        onSearch={() => {
          onDocumentChange();
        }}
        onChange={(event) => {
          const inputValue = event.target?.value ?? '';
          setValue(inputValue);

          if (!inputValue.length) {
            setSearchText({
              text: '',
              type,
              allowDocumentCount: type === 'document',
              is_documents: type === 'document',
              is_drafts: type === 'draft',
              is_all: type === 'true',
            });
          }
        }}
        value={value}
        allowClear
        onClear={() => {
          setValue('');
          setSearchText({
            text: '',
            type: 'node',
            allowDocumentCount: type === 'document',
            is_documents: type === 'document',
            is_all: type === 'true',
            is_drafts: type === 'drafts',
          });
        }}
      />
    </div>
  );
};
